var jade = require("/opt/actions-runner/_work/DI-Plan-Go-web/DI-Plan-Go-web/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

var jade_indent = [];
buf.push("\n<div>\n  <div ng-if=\"customer.route.routeSequenceDelivery &amp;&amp; ! customer.route.timestampStop\" class=\"cell stopno\"><span class=\"label\">{{ t('distributionDriverStop') }}</span><span class=\"stopno\"><span class=\"circle color-{{ customer.route.color }}\">{{ customer.route.routeSequenceDelivery }}</span></span></div>\n  <div class=\"cell\"><span class=\"label\">{{ t('distributionCompany') }}</span><span>{{ customer.route.companyName }}</span></div>\n  <div ng-if=\"customer.route.driver.name\" class=\"cell\"><span class=\"label\">{{ t('fleetDashDriver') }}</span><span>\n       \n      {{ customer.route.driver.name }}<span ng-if=\"customer.route.driver.phone\">&nbsp;({{ formatPhone(customer.route.driver.phone) }})</span></span></div>\n</div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/html/templates/routeInfoTooltip.jade
 ** module id = 100
 ** module chunks = 1
 **/